import { loanDenialReasonsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_DENIAL_ACTION_TYPE = createNamedActions('loanDenial', {
  GET_LOAN_DENIAL_REASONS: 'GET_LOAN_DENIAL_REASONS',
  UPDATE_LOAN_DENIAL_REASONS: 'UPDATE_LOAN_DENIAL_REASONS',
});

const remapLoanDenialReasons = data =>
  data.map(
    ({
      denialReason: { id, companyId, name, hmdaCode, otherReason, denialDueToCredit, isAffiliate },
      ...loanDenial
    }) => ({
      ...loanDenial,
      denialReason: {
        id,
        companyId,
        name,
        HMDACode: hmdaCode,
        otherReason,
        isDenialDueToCredit: denialDueToCredit,
        isAffiliate,
      },
    }),
  );

export const getLoanDenialReasonsByLoanIdAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await loanDenialReasonsApi.getLoanDenialReasons(params);

    return dispatch({
      type: LOAN_DENIAL_ACTION_TYPE.GET_LOAN_DENIAL_REASONS,
      payload: remapLoanDenialReasons(data),
    });
  },
);

export const updateLoanDenialReasonsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanDenialReasonsApi.updateAllLoanDenialReasons(params);

  return dispatch({
    type: LOAN_DENIAL_ACTION_TYPE.UPDATE_LOAN_DENIAL_REASONS,
    payload: remapLoanDenialReasons(data),
  });
});
